var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fees-wrapper px-3" },
    [
      _c("div", { staticClass: "card-header pb-4 sticky-top" }, [
        _c(
          "div",
          { staticClass: "row align-items-center justify-content-between" },
          [
            _c("div", { staticClass: "font-italic text-right text-gray" }, [
              !_vm.feesSavingStatus
                ? _c(
                    "span",
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("global.actions.lastSaved")) +
                          ":\n          "
                      ),
                      _c("refreshable-time-ago", {
                        attrs: { date: _vm.updatedFeesAt },
                      }),
                    ],
                    1
                  )
                : _c("span", [
                    _vm._v(_vm._s(_vm.$t("global.words.saving")) + "..."),
                  ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "py-3" },
              [
                _c("fees-mortgage-selector", {
                  attrs: { "requested-mortgages": _vm.REQUESTED_MORTGAGES },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row align-items-end" },
          _vm._l(_vm.columnHeaders, function (columnHeader, index) {
            return _c(
              "div",
              { key: "column-header-" + index, class: columnHeader.size },
              [
                _c(
                  "h6",
                  {
                    staticClass:
                      "theader theader-big m-0 cursor-auto text-left text-lg-center d-none d-lg-block",
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(columnHeader.label) + "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "h6",
                  {
                    staticClass:
                      "theader theader-big m-0 cursor-auto text-left text-lg-center d-lg-none d-block",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(columnHeader.shortLabel || columnHeader.label) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("fees-costs-loader")
        : _c(
            "div",
            { staticClass: "card-body" },
            _vm._l(_vm.feesCostsByMortgageType, function (feeCost, index) {
              return _c("fees-cost", {
                key: "feesCost.feeName-" + index,
                attrs: { "fee-cost": feeCost },
                on: {
                  remove: function ($event) {
                    return _vm.handleRemoveFee(index)
                  },
                  save: _vm.handleSave,
                },
              })
            }),
            1
          ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-row justify-content-end" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary btn-sm mt-2",
            on: { click: _vm.handleAddFee },
          },
          [
            _vm._v(
              "\n      + " +
                _vm._s(_vm.$t("direct-to-lender.fees.addNewFeeCost")) +
                "\n    "
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }